import { ReactNode } from 'react'

import { Link } from 'react-router'

interface ProductWrapperProps {
  children: ReactNode,
  href: string,
  slug: string,
  disabled?: boolean,
  className?: string,
}

export const ProductWrapper = ({
  children,
  href,
  slug,
  disabled = false,
  className,
}: ProductWrapperProps) => {
  if (disabled) {
    return (
      <div data-testid={`product tile ${slug}`} className={className}>
        {children}
      </div>
    )
  }
  return (
    <Link
      to={href}
      data-testid={`product tile link ${slug}`}
      className={className}
    >
      {children}
    </Link>
  )
}